import {Component, EventEmitter, Input, Output, ViewEncapsulation, ElementRef} from '@angular/core';
import {format} from 'date-fns';
import {environment} from 'src/environments/environment';
import {PrintApplicationData} from '../../shared/models/print';
import {AbstractPrintComponent} from '../abstract-print/abstract-print.component';
import {DocumentType} from '../../shared/models/user';
import {ApiService} from 'src/app/shared/services/api.service';
import {PlacesService} from 'src/app/shared/services/places.service';
import {RequestService} from 'src/app/shared/services/request.service';
import {SyncService} from 'src/app/shared/services/sync.service';
import {PlatformEvent, PlatformEventType} from 'src/app/shared/models/information';
import {RequestWithDuplicata, Request} from 'src/app/shared/models/request';

@Component({
  selector: 'app-print-data',
  template: `
<div id="print">
  <div class="print_content">
    <div class="flex f_between f_align_c mb_10">
      <div class="flex f_align_start gap_10">
        <div class="f_col f_align_c" *ngIf="environment.showEmblemPrint">
          <img src="assets/emblem.png" width="80px" alt="">
        </div>
        <div class="f_col f_end mt_10">
          <img [src]="environment.theme.logo" width="50px" alt="">
        </div>
        <div class="f_col f_align_c" *ngIf="environment.showLogoPrint">
          <img src="assets/zimmigration.png" width="68px" alt="">
        </div>
      </div>
      <div class="f_col f_align_end print_header">
        <span class="text-right" [innerHtml]="data.title | translate"></span>
      </div>
    </div>
    <div *ngFor="let group of data.dataList">
      <h3 class="text_center group-subtitle">{{ group.subtitle }}</h3>
      <table class="fullWidth">
        <tbody>
          <tr *ngFor="let item of group.data">
            <td>
              <b>{{ item[0] }}</b>
            </td>
            <td>{{ item[1] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
  `,
  styles: [`
@media print {
  body, html{
    overflow: auto !important;
    height: auto !important;
    width:  auto !important;
  }
}

#print {
  height: auto;
  width: auto;
  display: none;
  justify-content: center;
  background: white;
  color: black;
  padding: 5%;
  overflow: auto;
  position: relative;

  .print_content {
    counter-reset: page;
    width: 600px;
    margin: 0 auto;

    table {
      width: 100%;
      border-collapse: collapse;
      margin: 0 auto;
    }

    th, td {
      border: 1px solid gray;
      text-align: start;
    }

    td{
      width: 300px;
      font-size: 12px !important;
    }

    tr {
      border-bottom: 1px solid gray;
    }


    td {
      padding: 0px 4px;

      &:first-of-type {
        text-align: start;
        font-weight: bold;
      }
      &:last-of-type {
        text-align: end;
      }

      &.tableDataBackground {
        background-color: #f2f2f2;
        text-transform: uppercase;
      }
    }

    .group {
      break-before: page;
      padding-top: 10px;
    }
  }

  @media print {
    display: block;
  }
  .print-title{
    font-weight: 700;
    text-align: center;
    font-size: 14px;
  }
  .group-subtitle{
    margin-bottom: 0;
    font-size: 12px;
    display: block;
  }
  .print-logo{
    position: absolute;
  }
}

.text-right {
  text-align: end;
}
  `],
  encapsulation: ViewEncapsulation.None
})
export class PrintDataComponent extends AbstractPrintComponent {
  @Input() data: PrintApplicationData;
  @Output() init = new EventEmitter<void>();
  protected readonly environment = environment;
  today = new Date();
  placeInfo: {person_id: string, longName: string} | null = null;
  officerEvent: PlatformEvent | undefined;
  officerPlaceId: string | undefined;
  officerDateOfIssue: string;
  passportExpiryDate: string;

  constructor(public api: ApiService,
    private places: PlacesService,
    private request: RequestService,
    public sync: SyncService,
    elRef: ElementRef) {
    super(elRef);
  }

  ngOnInit(): void {
    const request = this.data?.request as RequestWithDuplicata | Request;
    const events = request.events;

    this.officerEvent = Array.isArray(events) ? this.getOfficerPaymentUse(events) : undefined;
    this.officerPlaceId = this.officerEvent?.place_id;
    this.officerDateOfIssue = this.officerEvent?.updatedOn;
    this.passportExpiryDate = this.data?.request?.metadata?.DateOfExpiry ? format(new Date(+this.data.request.metadata.DateOfExpiry), 'dd/MM/yyyy') : '';

    if(this.officerPlaceId) {
      this.places.getPlace(this.officerPlaceId).then(place => {
        this.placeInfo = {person_id: place.person_id, longName: place.longName};
      });
    }
  }

  get fundsDisplay(): string {
    return this.request.getFundsDisplay(this.data?.request?.metadata?.FundsAvailable, this.data?.request?.metadata?.FundsAvailableCurrency);
  }

  getOfficerPaymentUse(events: PlatformEvent[]) {
    if(!Array.isArray(events)) return undefined;
    return events.find((event) => event?.type === PlatformEventType.PAYMENT_USED);
  }

  protected readonly DocumentType = DocumentType;
}
